import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* globals window */
import { Container } from 'unstated';

function defaultStateName(container) {
  var name = container.constructor.name;
  return name.replace(/Container$/, '');
}
/**
 * This is a base class for unstated containers that will
 * pull from req.initialState on the server (via the unstated-decorator in config)
 * and window.PreloadedState on the browser. The name of the PreloadedState key
 * can be passed as a second constructor param, else we will look for the
 * class name w/o "Container" at the end.
 */


var IsomorphicContainer =
/*#__PURE__*/
function (_Container) {
  _inherits(IsomorphicContainer, _Container);

  function IsomorphicContainer(initialState, preloadedStateName) {
    var _this;

    _classCallCheck(this, IsomorphicContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IsomorphicContainer).call(this));
    var state = initialState;

    if (!state && typeof window !== 'undefined') {
      var _window, _window$PreloadedStat;

      state = (_window = window) === null || _window === void 0 ? void 0 : (_window$PreloadedStat = _window.PreloadedState) === null || _window$PreloadedStat === void 0 ? void 0 : _window$PreloadedStat[preloadedStateName || defaultStateName(_assertThisInitialized(_this))];
    }

    if (!state) {
      state = {};
    }

    _this.state = state;
    return _this;
  }

  _createClass(IsomorphicContainer, [{
    key: "toJSON",
    value: function toJSON() {
      return this.state;
    }
  }]);

  return IsomorphicContainer;
}(Container);

export { IsomorphicContainer as default };